@if (isActive) {
  <topo-modal [isActive]="isActive" (close)="onClose()" [isCard]="true" id="workflow-transition-modal">
    <div class="modal-header">
      <div class="mx-4 my-4" fxLayout="row" fxLayoutAlign="space-between">
        @if (isActive) {
          <h5>{{ 'MANAGEMENT.WORKFLOW.TRANSITION-FORM' | translate }}</h5>
        }
      </div>
    </div>
    <div class="modal-body">
      <div
        topoDynamicForm
        [formView]="editView"
        [schema]="schema"
        [document]="document"
        [controlCollection]="controls"
        [isEdit]="true"
        [dataset]="dataset"
        [layerUId]="guidEmpty"
      ></div>
    </div>
    <div class="modal-footer">
      <section class="field buttons mt-3" fxLayout="row" fxLayoutAlign="end">
        <button class="button is-secondary mr-2" (click)="onClose()">{{ 'MANAGEMENT.DATAFEEDS.CANCEL' | translate
        }}</button>
        <button class="button is-primary" (click)="saveClick()">{{ 'MANAGEMENT.DATAFEEDS.SAVE' | translate }}</button>
      </section>
    </div>
  </topo-modal>
}
